export enum UserManagerAdminGroup {
  UserSiteAssigner = 'UserSiteAssigner',
  /** Delegated user manager (Feature #6256): manages only users of the active site with delegable groups; never sees roles. */
  UserManagerDelegate = 'UserManagerDelegate',
}
